import React from "react";
import { useRef } from 'react';
import ReactDOM from "react-dom/client";
import Footer from "./footer";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { useForm, Controller } from "react-hook-form";
import {
    TextField, MenuItem, Select, Grid, Box, Checkbox, Alert, InputLabel, FormControl, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton
} from "@mui/material";

// import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
// import InstagramIcon from "@mui/icons-material/Instagram";
import CloseIcon from '@mui/icons-material/Close';
import HomeIcon from "@mui/icons-material/Home";
import CallIcon from "@mui/icons-material/Call";

import defaultImage from "../src/images/noimage2.png";
// import footerImage from "../src/images/whitelogo1.png";
// import appleImage from "../src/images/apple.png";
// import googleImage from "../src/images/google.png";
// import huaweiImage from "../src/images/huawei.png";

import axios from "axios";
import PhoneInput, { isValidPhoneNumber } from "react-phone-input-2";
import { usePlacesWidget } from "react-google-autocomplete";
import ReCAPTCHA from "react-google-recaptcha";

import "react-phone-input-2/lib/material.css";

import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

// Tan Zin Wei, 2023-12-01, Create the array store alpha2 , alpha3 and name for dropdownlist and google map
const countryMappings = [
  { alpha2: "AF", alpha3: "AFG", name: "Afghanistan" },
  { alpha2: "AL", alpha3: "ALB", name: "Albania" },
  { alpha2: "DZ", alpha3: "ALG", name: "Algeria" },
  { alpha2: "AD", alpha3: "AND", name: "Andorra" },
  { alpha2: "AO", alpha3: "ANG", name: "Angola" },
  { alpha2: "AI", alpha3: "ANU", name: "Anguilla" },
  { alpha2: "AG", alpha3: "ANT", name: "Antigua And Barbuda" },
  { alpha2: "AR", alpha3: "ARG", name: "Argentina" },
  { alpha2: "AM", alpha3: "ARM", name: "Armenia" },
  { alpha2: "AW", alpha3: "ARU", name: "Aruba" },
  { alpha2: "AU", alpha3: "AUS", name: "Australia" },
  { alpha2: "AT", alpha3: "AUT", name: "Austria" },
  { alpha2: "AZ", alpha3: "AZE", name: "Azerbaijian" },
  { alpha2: "AS", alpha3: "AMS", name: "American Samoa" },
  { alpha2: "BS", alpha3: "BHM", name: "Bahamas" },
  { alpha2: "BH", alpha3: "BHR", name: "Bahrain" },
  { alpha2: "BD", alpha3: "BGD", name: "Bangladesh" },
  { alpha2: "BB", alpha3: "BBD", name: "Barbados" },
  { alpha2: "BY", alpha3: "BEL", name: "Belarus" },
  { alpha2: "BE", alpha3: "BGM", name: "Belgium" },
  { alpha2: "BZ", alpha3: "BLZ", name: "Belize" },
  { alpha2: "BJ", alpha3: "BEN", name: "Benin" },
  { alpha2: "BM", alpha3: "BMD", name: "Bermuda" },
  { alpha2: "BT", alpha3: "BHU", name: "Bhutan" },
  { alpha2: "BO", alpha3: "BOL", name: "Bolivia" },
  { alpha2: "BA", alpha3: "BOS", name: "Bosnia-Herzegovina" },
  { alpha2: "BW", alpha3: "BWN", name: "Botswana" },
  { alpha2: "BV", alpha3: "BOU", name: "Bouvet Island" },
  { alpha2: "BR", alpha3: "BRA", name: "Brazil" },
  { alpha2: "BN", alpha3: "BRU", name: "Brunei" },
  { alpha2: "BG", alpha3: "BUL", name: "Bulgaria" },
  { alpha2: "BF", alpha3: "BUR", name: "Burkina Faso" },
  { alpha2: "BI", alpha3: "BUD", name: "Burundi" },
  { alpha2: "KH", alpha3: "CAM", name: "Cambodia" },
  { alpha2: "CM", alpha3: "CAR", name: "Cameroon" },
  { alpha2: "CA", alpha3: "CND", name: "Canada" },
  { alpha2: "CV", alpha3: "CAP", name: "Cape Verde" },
  { alpha2: "IC", alpha3: "CAY", name: "Cayman Islands" },
  { alpha2: "CF", alpha3: "CEN", name: "Central African Republic" },
  { alpha2: "TD", alpha3: "CHA", name: "Chad" },
  { alpha2: "CL", alpha3: "CHI", name: "Chile" },
  { alpha2: "CN", alpha3: "CHN", name: "China" },
  { alpha2: "CX", alpha3: "CHR", name: "Christmas Island" },
  { alpha2: "CC", alpha3: "COC", name: "Cocos (Keeling) Islands" },
  { alpha2: "CO", alpha3: "COL", name: "Colombia" },
  { alpha2: "KM", alpha3: "COM", name: "Comoros" },
  { alpha2: "CD", alpha3: "COR", name: "Congo, Republic Of" },
  { alpha2: "CK", alpha3: "COO", name: "Cook Islands" },
  { alpha2: "CR", alpha3: "COS", name: "Costa Rica" },
  { alpha2: "HR", alpha3: "CRO", name: "Croatia" },
  { alpha2: "CU", alpha3: "CUB", name: "Cuba" },
  { alpha2: "CY", alpha3: "CYP", name: "Cyprus" },
  { alpha2: "CZ", alpha3: "CZR", name: "Czech Republic" },
  { alpha2: "DK", alpha3: "DEN", name: "Denmark" },
  { alpha2: "DJ", alpha3: "DJI", name: "Djibouti" },
  { alpha2: "DM", alpha3: "DOM", name: "Dominica" },
  { alpha2: "DO", alpha3: "DOP", name: "Dominican Republic" },
  { alpha2: "EC", alpha3: "ECU", name: "Ecuador" },
  { alpha2: "EG", alpha3: "EGY", name: "Egypt" },
  { alpha2: "SV", alpha3: "ELS", name: "El Salvador" },
  { alpha2: "GQ", alpha3: "EQU", name: "Equatorial Guinea" },
  { alpha2: "ER", alpha3: "ERI", name: "Eritrea" },
  { alpha2: "EE", alpha3: "EST", name: "Estonia" },
  { alpha2: "ET", alpha3: "ETH", name: "Ethiopia" },
  { alpha2: "FK", alpha3: "FAL", name: "Falkland Islands" },
  { alpha2: "FO", alpha3: "FAR", name: "Faroe Islands" },
  { alpha2: "FJ", alpha3: "FIJ", name: "Fiji" },
  { alpha2: "FI", alpha3: "FIN", name: "Finland" },
  { alpha2: "FR", alpha3: "FRA", name: "France" },
  { alpha2: "GF", alpha3: "FRE", name: "French Guiana" },
  { alpha2: "GA", alpha3: "GAB", name: "Gabon" },
  { alpha2: "GM", alpha3: "GAM", name: "Gambia" },
  { alpha2: "GE", alpha3: "GEO", name: "Georgia" },
  { alpha2: "DE", alpha3: "GER", name: "Germany" },
  { alpha2: "GH", alpha3: "GHA", name: "Ghana" },
  { alpha2: "GI", alpha3: "GIB", name: "Gibraltar" },
  { alpha2: "GR", alpha3: "GRE", name: "Greece" },
  { alpha2: "GL", alpha3: "GRL", name: "Greenland" },
  { alpha2: "GD", alpha3: "GRN", name: "Grenada" },
  { alpha2: "GP", alpha3: "GUA", name: "Guadeloupe (French)" },
  { alpha2: "GU", alpha3: "GUM", name: "Guam (Usa)" },
  { alpha2: "GT", alpha3: "GUT", name: "Guatemala" },
  { alpha2: "GN", alpha3: "GUI", name: "Guinea" },
  { alpha2: "GW", alpha3: "GUB", name: "Guinea Bissau" },
  { alpha2: "GY", alpha3: "GUY", name: "Guyana" },
  { alpha2: "HT", alpha3: "HAI", name: "Haiti" },
  { alpha2: "HM", alpha3: "HOL", name: "Holy See" },
  { alpha2: "HN", alpha3: "HON", name: "Honduras" },
  { alpha2: "HK", alpha3: "HKG", name: "Hong Kong" },
  { alpha2: "HU", alpha3: "HUN", name: "Hungary" },
  { alpha2: "IS", alpha3: "ICE", name: "Iceland" },
  { alpha2: "IN", alpha3: "IND", name: "India" },
  { alpha2: "ID", alpha3: "IDN", name: "Indonesia" },
  { alpha2: "IR", alpha3: "IRN", name: "Iran" },
  { alpha2: "IQ", alpha3: "IRQ", name: "Iraq" },
  { alpha2: "IE", alpha3: "IRE", name: "Ireland" },
  { alpha2: "IL", alpha3: "ISR", name: "Israel" },
  { alpha2: "IT", alpha3: "ITA", name: "Italy" },
  { alpha2: "CI", alpha3: "IVO", name: "Ivory Coast (Cote D'Ivoire)" },
  { alpha2: "JM", alpha3: "JAM", name: "Jamaica" },
  { alpha2: "JP", alpha3: "JPN", name: "Japan" },
  { alpha2: "JO", alpha3: "JOR", name: "Jordan" },
  { alpha2: "KZ", alpha3: "KAZ", name: "Kazakhstan" },
  { alpha2: "KE", alpha3: "KEN", name: "Kenya" },
  { alpha2: "KI", alpha3: "KIR", name: "Kiribati" },
  { alpha2: "KW", alpha3: "KUW", name: "Kuwait" },
  { alpha2: "KG", alpha3: "KYR", name: "Kyrgyzstan" },
  { alpha2: "LA", alpha3: "LAO", name: "Laos" },
  { alpha2: "LV", alpha3: "LAT", name: "Latvia" },
  { alpha2: "LB", alpha3: "LEB", name: "Lebanon" },
  { alpha2: "LS", alpha3: "LES", name: "Lesotho" },
  { alpha2: "LR", alpha3: "LIB", name: "Liberia" },
  { alpha2: "LY", alpha3: "LBY", name: "Libya" },
  { alpha2: "LI", alpha3: "LIE", name: "Liechtenstein" },
  { alpha2: "LT", alpha3: "LIT", name: "Lithuania" },
  { alpha2: "LU", alpha3: "LUX", name: "Luxembourg" },
  { alpha2: "MO", alpha3: "MCA", name: "Macau" },
  { alpha2: "MK", alpha3: "MAC", name: "Macedonia" },
  { alpha2: "MG", alpha3: "MAD", name: "Madagascar" },
  { alpha2: "MW", alpha3: "MLW", name: "Malawi" },
  { alpha2: "MY", alpha3: "MYS", name: "Malaysia" },
  { alpha2: "MV", alpha3: "MDV", name: "Maldives" },
  { alpha2: "ML", alpha3: "MAL", name: "Mali" },
  { alpha2: "MT", alpha3: "MLT", name: "Malta" },
  { alpha2: "MH", alpha3: "MAR", name: "Marshall Islands" },
  { alpha2: "MQ", alpha3: "MTQ", name: "Martinique (French)" },
  { alpha2: "MR", alpha3: "MTA", name: "Mauritania" },
  { alpha2: "MU", alpha3: "MTS", name: "Mauritius" },
  { alpha2: "YT", alpha3: "MAY", name: "Mayotte" },
  { alpha2: "MX", alpha3: "MEX", name: "Mexico" },
  { alpha2: "FM", alpha3: "MIC", name: "Micronesia" },
  { alpha2: "MD", alpha3: "MLV", name: "Moldova" },
  { alpha2: "MC", alpha3: "MOC", name: "Monaco" },
  { alpha2: "MN", alpha3: "MGL", name: "Mongolia" },
  { alpha2: "ME", alpha3: "MTN", name: "Montenegro" },
  { alpha2: "MS", alpha3: "MSR", name: "Montserrat" },
  { alpha2: "MA", alpha3: "MRC", name: "Morocco" },
  { alpha2: "MZ", alpha3: "MOZ", name: "Mozambique" },
  { alpha2: "MM", alpha3: "MYN", name: "Myanmar" },
  { alpha2: "NA", alpha3: "NAM", name: "Namibia" },
  { alpha2: "NR", alpha3: "NAU", name: "Nauru" },
  { alpha2: "NP", alpha3: "NEP", name: "Nepal" },
  { alpha2: "NL", alpha3: "NET", name: "Netherlands" },
  //{ alpha2: "", alpha3: "NTA", name: "Netherlands Antilles" }, //Tan Zin Wei, 2023-12-01, Google Map Api dont have Netherlands Antilles
  { alpha2: "NC", alpha3: "NCA", name: "New Caledonia (French)" },
  { alpha2: "NZ", alpha3: "NZL", name: "New Zeland" },
  { alpha2: "NI", alpha3: "NIC", name: "Nicaragua" },
  { alpha2: "NE", alpha3: "NIR", name: "Niger" },
  { alpha2: "NG", alpha3: "NIG", name: "Nigeria" },
  { alpha2: "NU", alpha3: "NIU", name: "Niue" },
  { alpha2: "NF", alpha3: "NFI", name: "Norfolk Island" },
  { alpha2: "KP", alpha3: "NKR", name: "North Korea" },
  { alpha2: "MP", alpha3: "NMI", name: "Northern Mariana Islands" },
  { alpha2: "NO", alpha3: "NOR", name: "Norway" },
  { alpha2: "OM", alpha3: "OMN", name: "Oman" },
  { alpha2: "PK", alpha3: "PAK", name: "Pakistan" },
  { alpha2: "PW", alpha3: "PAL", name: "Palau" },
  { alpha2: "PA", alpha3: "PAN", name: "Panama" },
  { alpha2: "PG", alpha3: "PAP", name: "Papua New Guinea" },
  { alpha2: "PY", alpha3: "PAR", name: "Paraguay" },
  { alpha2: "PE", alpha3: "PER", name: "Peru" },
  { alpha2: "PH", alpha3: "PHI", name: "Philippines" },
  { alpha2: "PN", alpha3: "PIT", name: "Pitcairn Island" },
  { alpha2: "PL", alpha3: "POL", name: "Poland" },
  { alpha2: "PF", alpha3: "PNS", name: "Polynesia (French)" },
  { alpha2: "PT", alpha3: "POR", name: "Portugal" },
  { alpha2: "PR", alpha3: "PUE", name: "Puerto Rico" },
  { alpha2: "QA", alpha3: "QAT", name: "Qatar" },
  { alpha2: "RE", alpha3: "REU", name: "Reunion" },
  { alpha2: "RO", alpha3: "ROM", name: "Romania" },
  { alpha2: "RU", alpha3: "RUS", name: "Russia" },
  { alpha2: "RW", alpha3: "RWA", name: "Rwanda" },
  { alpha2: "SH", alpha3: "SAH", name: "Saint Helena" },
  { alpha2: "KN", alpha3: "SAK", name: "Saint Kitts And Nevis" },
  { alpha2: "WS", alpha3: "SAM", name: "Samoa" },
  { alpha2: "SM", alpha3: "SAN", name: "San Marino" },
  { alpha2: "ST", alpha3: "SAO", name: "Sao Tome And Principe" },
  { alpha2: "SA", alpha3: "SAU", name: "Saudi Arabia" },
  { alpha2: "SN", alpha3: "SEN", name: "Senegal" },
  { alpha2: "RS", alpha3: "SER", name: "Serbia" },
  { alpha2: "SC", alpha3: "SEY", name: "Seychelles" },
  { alpha2: "SL", alpha3: "SIE", name: "Sierra Leone" },
  { alpha2: "SG", alpha3: "SGP", name: "Singapore" },
  { alpha2: "SX", alpha3: "SLO", name: "Slovakia" },
  { alpha2: "SI", alpha3: "SBN", name: "Slovenia" },
  { alpha2: "SB", alpha3: "SOL", name: "Solmon Islands" },
  { alpha2: "SO", alpha3: "SOM", name: "Somalia" },
  { alpha2: "ZA", alpha3: "SAF", name: "South Africa" },
  { alpha2: "KR", alpha3: "SKR", name: "South Korea" },
  { alpha2: "ES", alpha3: "SPA", name: "Spain" },
  { alpha2: "LK", alpha3: "SRI", name: "Sri Lanka" },
  { alpha2: "SD", alpha3: "SUD", name: "Sudan" },
  { alpha2: "SR", alpha3: "SUR", name: "Suriname" },
  //{ alpha2: "", alpha3: "SWA", name: "Swaziland" }, //Tan Zin Wei, 2023-12-01, Google Map Api dont have Swaziland
  { alpha2: "SE", alpha3: "SWE", name: "Sweden" },
  { alpha2: "CH", alpha3: "SWI", name: "Switzerland" },
  { alpha2: "SY", alpha3: "SYR", name: "Syria" },
  { alpha2: "LC", alpha3: "SLC", name: "Saint Lucia" },
  { alpha2: "LC", alpha3: "SAP", name: "Saint Pierre And Miquelon" },
  { alpha2: "TW", alpha3: "TWN", name: "Taiwan" },
  { alpha2: "TJ", alpha3: "TAJ", name: "Tajikistan" },
  { alpha2: "TZ", alpha3: "TAN", name: "Tanzania" },
  { alpha2: "TH", alpha3: "THI", name: "Thailand" },
  { alpha2: "TL", alpha3: "TIM", name: "Timor-Leste (East Timor)" },
  { alpha2: "TG", alpha3: "TOG", name: "Togo" },
  { alpha2: "TK", alpha3: "TOK", name: "Tokelau" },
  { alpha2: "TO", alpha3: "TON", name: "Tonga" },
  { alpha2: "TT", alpha3: "TRI", name: "Trinidad And Tobago" },
  { alpha2: "TN", alpha3: "TUN", name: "Tunisia" },
  { alpha2: "TR", alpha3: "TUR", name: "Turkey" },
  { alpha2: "TM", alpha3: "TRK", name: "Turkmenistan" },
  { alpha2: "TC", alpha3: "TCI", name: "Turks And Caicos Islands" },
  { alpha2: "TV", alpha3: "TUV", name: "Tuvalu" },
  { alpha2: "UG", alpha3: "UGA", name: "Uganda" },
  { alpha2: "UA", alpha3: "UKR", name: "Ukraine" },
  { alpha2: "AE", alpha3: "UAE", name: "United Arab Emirates" },
  { alpha2: "GB", alpha3: "UKD", name: "United Kingdom" },
  { alpha2: "US", alpha3: "USA", name: "United States" },
  { alpha2: "UY", alpha3: "URU", name: "Uruguay" },
  { alpha2: "UZ", alpha3: "UZB", name: "Uzbekistan" },
  { alpha2: "VU", alpha3: "VAN", name: "Vanuatu" },
  { alpha2: "VE", alpha3: "VEN", name: "Venezuela" },
  { alpha2: "VN", alpha3: "VTN", name: "Vietnam" },
  { alpha2: "VI", alpha3: "VIR", name: "Virgin Islands" },
  { alpha2: "WF", alpha3: "WAL", name: "Wallis And Futuna Islands" },
  { alpha2: "YE", alpha3: "YEM", name: "Yemen" },
  { alpha2: "ZM", alpha3: "ZAM", name: "Zambia" },
  { alpha2: "ZW", alpha3: "ZIM", name: "Zimbabwe" },
];

const getAlpha3FromAlpha2 = (alpha2) => {
  const country = countryMappings.find((country) => country.alpha2 === alpha2);
  return country ? country.alpha3 : null;
};

// Define an object mapping MenuItem values to their corresponding state values
const stateMappings = {
  Johor: "Johor",
  Kedah: "Kedah",
  Kelantan: "Kelantan",
  Melaka: "Melaka",
  Malacca: "Melaka",
  "Negeri Sembilan": "Negeri Sembilan",
  Pahang: "Pahang",
  Perak: "Perak",
  Perlis: "Perlis",
  "Pulau Pinang": "Pulau Pinang",
  Sabah: "Sabah",
  Sarawak: "Sarawak",
  Selangor: "Selangor",
  Terengganu: "Terengganu",
  "Wilayah Persekutuan Kuala Lumpur": "Wilayah Persekutuan Kuala Lumpur",
  "Federal Territory of Kuala Lumpur": "Wilayah Persekutuan Kuala Lumpur",
  "Wilayah Persekutuan Labuan": "Wilayah Persekutuan Labuan",
  "Wilayah Persekutuan Putrajaya": "Wilayah Persekutuan Putrajaya",
};

const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];

// Tan Zin Wei, 2023-11-29, Valid the image is not corrupted or invalid
const validateImage = async (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      // Image loaded successfully
      resolve(true);
    };
    img.onerror = () => {
      // Error occurred while loading the image
      reject(false);
    };
    img.src = URL.createObjectURL(file);
  });
};

const schema = yup
  .object()
  .shape({
    companyName: yup
      .string()
      .trim()
      .required("You must key in company name")
      .max(200, "Your company name exceeds 200 characters"),
    brandName: yup
      .string()
      .trim()
      .required("You must key in brand name")
      .max(50, "Your brand name exceeds 50 characters"),
    industry: yup.string().trim().required("You must select an industry"),
    outletName: yup
      .string()
      .trim()
      .required("You must key in outlet name")
      .max(50, "Your outlet name exceeds 50 characters"),
    outletAddress: yup
      .string()
      .trim()
      .required("You must key in outlet address")
      .max(200, "Your address exceeds 200 characters"),
    postCode: yup
      .string()
      .trim()
      .required("You must key in postcode")
      .matches(/[0-9]/, "You must key in number")
      .max(12, "Your postcode exceeds 12 characters"),
    state: yup.string().when("country", {
      is: "MYS",
      then: yup.string(),
      otherwise: yup
        .string()
        .trim()
        .required("You must key in outlet state")
        .max(50, "Your state exceeds 50 characters"),
    }),
    picName: yup
      .string()
      .trim()
      .required("You must key in your name")
      .max(50, "Your name exceeds 50 characters"),
    picEmail: yup
      .string()
      .trim()
      .required("You must key in your email address")
      .matches(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        "You must key in a valid email address"
      ),
    picContactNo: yup
      .string()
      .trim()
      .required("You must key in your contact number")
      .matches(
        /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
        "You must key in a valid phone number"
      ),

    logo: yup
      .mixed()
      .test("required", "You need to provide a image", (value) => {
        return value && value.length;
      })
      .test(
        "fileSize",
        "The image is too large.(Size must less than 1024x1024 pixels) ",
        (value) => {
          return !value || (value && value[0] && value[0].size < 1024 * 1024);
        }
      )
      .test("fileType", "You must upload JPG, JPEG or PNG logo", (value) => {
        return (
          !value ||
          (value && value[0] && SUPPORTED_FORMATS.includes(value[0].type))
        );
      })
      // Tan Zin Wei, 2023-11-29, Add the validation for valid the image is corrupted or invalid
      .test(
        "validImage",
        "The image is corrupted or invalid",
        async (value) => {
          if (value && value.length) {
            try {
              await validateImage(value[0]);
              return true;
            } catch (error) {
              return false;
            }
          }
          return true; // Pass the test if no file is provided
        }
      ),
    tnc: yup
      .bool() // use bool instead of boolean
      .oneOf([true], "You must accept the terms and conditions"),
    verificationCode: yup.string().when('$open', {
        is: true,
        then: yup.string()
          .trim()
          .required("Verification code is required")
          .matches(/^\d{6}$/, "Verification code must be exactly 6 digits"),
        otherwise: yup.string(),
      }),
  })
  .required();

let APIKey = "AIzaSyABNuIcLg5uIgenToWipHYqV_9S1ikZj-Q";
let latitude = "";
let longitude = "";
let captcha = "";
let responseCode = -1;
let responseClientId = -1;
let responseArray = [];
let responseArrayResend = [];
let responseEmailAddr = "";

function App() {
  const reCaptchaRef = useRef();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data, event) => {
    //console.log(JSON.stringify(data));

    event.preventDefault();
    
    // var logoFile = document.getElementById("logo").files[0];
    let base64 = "";

    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(";base64,")[1]);
        reader.onerror = (error) => reject(error);
      });

    async function SendEmail() {
      axios
        .post(
          "https://apistaging.haiico.com/SelfSignUp/SignUp/VerifyEmail", //TEST
          //'https://api.haiico.com/SelfSignUp/SignUp/VerifyEmail', //LIVE
          {
            picEmail: data.picEmail,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
    }

    async function Main() {
      const file = document.getElementById("logo").files[0];
      base64 = await toBase64(file);

      axios
        .post(
          "https://apistaging.haiico.com/SelfSignUp/SignUp/ExpressClientFREE", //TEST
          //'https://api.haiico.com/SelfSignUp/SignUp/ExpressClientFREE', //LIVE
          {
            companyName: data.companyName,
            brandName: data.brandName,
            industry: data.industry,
            logo: base64,
            outletName: data.outletName,
            outletAddress: data.outletAddress,
            postCode: data.postCode,
            state: data.country === "MYS" ? data.stateDDL : data.state,
            country: data.country,
            latitude: latitude.toString(),
            longitude: longitude.toString(),
            picName: data.picName,
            picEmail: data.picEmail,
            picContactNo: data.picContactNo,
            verificationCode: data.verificationCode
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            responseArray = response.data.split(";");
            responseCode = responseArray[0];
            if (responseCode == "0") {
              responseClientId = responseArray[1];
              responseEmailAddr = responseArray[2];
              reset();
              setSuccess(true);
              setFail(false);
              setDuplicate(false);
              setImage(defaultImage);
              setLoading(false);
              setFailVerification(false);
              setIndustry("");
              setCountry("MYS");
              setMalaysia(true);
              setState("Wilayah Persekutuan Kuala Lumpur");

              let element = document.getElementById("AlertMsg");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            } else if (responseCode == "1") {
              setSuccess(false);
              setFail(false);
              setDuplicate(true);
              setFailVerification(false);
              //setImage(defaultImage);
              setLoading(false);
              //setIndustry('');
              //setCountry('MYS');
              //setMalaysia(true);
              //setState('Wilayah Persekutuan Kuala Lumpur');

              let element = document.getElementById("AlertMsg");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            } else if (responseCode == "2") {
              setSuccess(false);
              setFail(false);
              setDuplicate(false);
              setFailVerification(true);
              //setImage(defaultImage);
              setLoading(false);
              //setIndustry('');
              //setCountry('MYS');
              //setMalaysia(true);
              //setState('Wilayah Persekutuan Kuala Lumpur');

              let element = document.getElementById("AlertMsg");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            } else {
              setSuccess(false);
              setFail(true);
              setDuplicate(false);
              //setImage(defaultImage);
              setLoading(false);
              setFailVerification(false);
              //setIndustry('');
              //setCountry('MYS');
              //setMalaysia(true);
              //setState('Wilayah Persekutuan Kuala Lumpur');

              let element = document.getElementById("AlertMsg");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }
          } else {
            setSuccess(false);
            setFail(true);
            setDuplicate(false);
            //setImage(defaultImage);
            setLoading(false);
            setFailVerification(false);
            //setIndustry('');
            //setCountry('MYS');
            //setMalaysia(true);
            //setState('Wilayah Persekutuan Kuala Lumpur');

            let element = document.getElementById("AlertMsg");
            if (element) {
              element.scrollIntoView({ behavior: "smooth" });
            }
          }
        });
    }
    
    try {
      await schema.validate(data, { context: { open: open } });
      
      if(!open){
        setValue('verificationCode', '');
        setOpen(true);
        const token = await reCaptchaRef.current.executeAsync();
        //console.log(token);
        if (token == "" || token === null) {
            //recaptcha appears
        } else {
          SendEmail();
        }
      }
      else{
        setOpen(false);
        setLoading(true);
        Main();
      }
    } catch (validationError) {
      setVerificationErrorMessage(validationError.errors[0]);
    }
  }; // your form submit function which will invoke after successful validation

  const handleInnerFormSubmit = (data, event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const [industry, setIndustry] = React.useState("");
  const [country, setCountry] = React.useState("MYS");
  const [stateDDL, setStateDDL] = React.useState(
    "Wilayah Persekutuan Kuala Lumpur"
  );
  const [state, setState] = React.useState("");
  const [postCode, setPostCode] = React.useState("");
  const [outletAddress, setOutletAddress] = React.useState("");

  const [loading, setLoading] = React.useState(false);
  const [recaptchaErr, setRecaptchaErr] = React.useState(false);

  const [previewedImage, setImage] = React.useState(defaultImage);

  const [isMalaysia, setMalaysia] = React.useState(true);

  const [isSuccess, setSuccess] = React.useState(false);
  const [isDuplicate, setDuplicate] = React.useState(false);
  const [isFail, setFail] = React.useState(false);
  const [isFailVerification, setFailVerification] = React.useState(false);

  const [isResendSuccess, setResendSuccess] = React.useState(false);
  const [isResendFail, setResendFail] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [verificationErrorMessage, setVerificationErrorMessage] = React.useState("");

  const handleClose = () => {
    setOpen(false);
  };

  let secret = "6LcxTpkkAAAAAE78lmKDx9zWd33-8o2AyWgBtNZS";

  function onChange(value) {
    captcha = value;
    // console.log("Captcha Onchange:" + captcha);
  }

  const { ref: mapRef } = usePlacesWidget({
    apiKey: { APIKey },
    onPlaceSelected: (place) => {
      latitude = place.geometry.location.lat();
      longitude = place.geometry.location.lng();
      let addressComponents = [];
      // Extract state, country, and postcode
      let state = "";
      let country = "";
      let postcode = "";
      // Iterate through address components to find the relevant data
      place.address_components.forEach((component) => {
        if (
          !component.types.includes("country") &&
          !component.types.includes("administrative_area_level_1") &&
          !component.types.includes("postal_code")
        ) {
          addressComponents.push(component.long_name); // Append non-state, non-country, non-postal code components to the full address
        } else {
          if (component.types.includes("country")) {
            country = component.short_name;
            // Check if the country exists in countryMappings
            const mappedCountry = getAlpha3FromAlpha2(country);
            if (mappedCountry) {
              if (mappedCountry === "MYS") {
                setMalaysia(true);
              } else {
                setMalaysia(false);
              }
              //console.log(mappedCountry);
              setCountry(mappedCountry);
              setValue("country", mappedCountry, { shouldValidate: true });
            }
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.long_name;
            setState(state);
            setValue("state", state, { shouldValidate: true });
            // Check if the state exists in stateMappings
            const mappedState = stateMappings[state];
            if (mappedState) {
              setStateDDL(mappedState);
              setValue("stateDDL", mappedState, { shouldValidate: true });
            }
          } else if (component.types.includes("postal_code")) {
            postcode = component.long_name;
            setPostCode(postcode);
            setValue("postCode", postcode, { shouldValidate: true });
          }
        }
      });
      // Check if addressComponents array is not empty before constructing the address string
      let address = "";
      if (addressComponents.length > 0) {
        // Construct the address string by joining components without a comma and space
        address = addressComponents.join(", ");
        setOutletAddress(address);
        setValue("outletAddress", address, { shouldValidate: true });
      }
      // Log state, country, and postcode
      console.log("State:", state);
      console.log("Country:", country);
      console.log("Postcode:", postcode);
      console.log("Address:", address);
      console.log(place);
    },
    options: {
      types: ["geocode", "establishment"],
    },
  });

  const handleInputChange = (fieldName, e) => {
    if (fieldName === "country") {
      if (e.target.value === "MYS") {
        setMalaysia(true);
      } else {
        setMalaysia(false);
      }
      setCountry(e.target.value);
    }
    if (fieldName === "stateDDL") {
      setStateDDL(e.target.value);
    }
    if (fieldName === "state") {
      setState(e.target.value);
    }
    if (fieldName === "industry") {
      setIndustry(e.target.value);
    }
    if (fieldName === "postCode") {
      setPostCode(e.target.value);
    }
    if (fieldName === "outletAddress") {
      setOutletAddress(e.target.value);
    }
    setValue(fieldName, e.target.value, { shouldValidate: true });
    //console.log(e.target.value);
  };

  function handleResendEmail(clientId) {
    setLoading(true);

    axios
      .post(
        "https://apistaging.haiico.com/SelfSignUp/SignUp/ResendEmail", //TEST
        //'https://api.haiico.com/SelfSignUp/SignUp/ResendEmail', //LIVE
        {
          clientId: clientId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setLoading(false);

        if (response.status == 200) {
          responseArrayResend = response.data.split(";");
          // responseEmailAddr = responseArrayResend[1];
          let responseStatusResend = responseArrayResend[0];

          if (responseStatusResend == "0") {
            setResendSuccess(true);

            let element = document.getElementById("AlertMsg");
            if (element) {
              element.scrollIntoView({ behavior: "smooth" });
            }
          } else {
            setResendSuccess(false);
            setResendFail(true);
          }
        } else {
          setResendSuccess(false);
          setResendFail(true);
        }
      });
  }

  const onSubmitFile = (event) => {
    var logoFile = document.getElementById("logo").files[0];

    if (logoFile) {
      var filereader = new FileReader();
      filereader.readAsDataURL(logoFile);
      filereader.onload = function (evt) {
        setImage(URL.createObjectURL(logoFile));
      };
          } else {
      setImage(defaultImage);
          }
  };

  return (
    <div>
      {(() => {
        if (!isSuccess) {
          return (
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* <h2 className='redHeading'>Company/Brand Information</h2> */}

              <div id="AlertMsg">
                {isSuccess && (
                  <Alert id="successMsg" severity="success">
                    Your account has been created successfully! Please check
                    your inbox with the email you registered with us.
                  </Alert>
                )}
                {isFail && (
                  <Alert id="failMsg" severity="error">
                    Oops! There are some issue creating your account. Please
                    contact us via Contact Us page below.
                  </Alert>
                )}
                {isDuplicate && (
                  <Alert id="failMsg" severity="error">
                    It seems that you have already registered with us before.
                    Please contact us to retrieve your account.
                  </Alert>
                )}
                {isFailVerification && (
                  <Alert id="failMsg" severity="error">
                    Oops! You have entered an invalid verification code.
                    Please try again.
                  </Alert>
                )}
                <div style={{ margin: "10px 0" }} />
              </div>

              <Grid container spacing={4}>
                <Grid container item xs={12} md={4} direction="column">
                  {/* <div className="logoImgDiv">
                                                    <label style={{ height: 133, width: 200 }} onChange={onSubmitFile}>
                                                        <img src={previewedImage} height='133' width='200' className="logoImg"></img>
                                                        <input id="logo" name="logo" type="file" {...register("logo")} style={{ display: 'none' }} />
                                                    </label>
                                                </div> */}
                  {/* TanZinWei, 2023-11-28, Fixed the didn't upload image make auto focus not working */}
                  <div
                    className="logoImgDiv"
                    style={{
                      width: 200,
                      height: 133,
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <label
                      style={{ position: "absolute", top: 0, left: 0 }}
                      onChange={onSubmitFile}
                    >
                      <img
                        src={previewedImage}
                        height="133"
                        width="200"
                        className="logoImg"
                        alt="Previewed Logo"
                      />
                      <input
                        id="logo"
                        name="logo"
                        type="file"
                        accept=".jpg, .jpeg, .png"
                        {...register("logo")}
                        style={{
                          position: "absolute",
                          opacity: 0,
                          top: 0,
                          left: 0,
                          height: "100%",
                          width: "100%",
                          cursor: "pointer",
                        }}
                                              />
                    </label>
                  </div>
                  <i className="uploadImageText">
                    Upload a logo by clicking the area above.
                  </i>

                  {errors.logo && (
                    <p className="errorMessage uploadImageText">{errors.logo.message}</p>
                  )}
                </Grid>

                <Grid container item xs={12} md={8} direction="column">
                  <TextField
                    variant="outlined"
                    label="Company Name *"
                    size="small"
                    {...register("companyName")}
                    onChange={(e) => handleInputChange("companyName", e)}
                  />
                  {errors.companyName && (
                    <p className="errorMessage">{errors.companyName.message}</p>
                  )}

                  {/* Tan Zin Wei, 2023-11-28, Comment the <br/>(Not Working in Firefox) replace to <div style={{ margin: '10px 0' }} /> */}
                  {/* <br /> */}
                  <div style={{ margin: "10px 0" }} />

                  <TextField
                    variant="outlined"
                    label="Brand Name *"
                    size="small"
                    {...register("brandName")}
                    onChange={(e) => handleInputChange("brandName", e)}
                  />
                  {errors.brandName && (
                    <p className="errorMessage">{errors.brandName.message}</p>
                  )}

                  <div style={{ margin: "10px 0" }} />

                  <FormControl>
                    <TextField
                      variant="outlined"
                      select
                      size="small"
                      {...register("industry")}
                      // Tan Zin Wei, 2023-11-28, Comment the minWidth
                      // sx={{ m: 1, minWidth: 120 }}
                      value={industry}
                      onChange={(e) => handleInputChange("industry", e)}
                      label="Business Industry *"
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value={"Agriculture"}>Agriculture</MenuItem>
                      <MenuItem value={"Business"}>Business</MenuItem>
                      <MenuItem value={"Construction"}>Construction</MenuItem>
                      <MenuItem value={"Fashion"}>Fashion</MenuItem>
                      <MenuItem value={"Finance"}>Finance</MenuItem>
                      <MenuItem value={"Food & Beverages"}>
                        Food & Beverages
                      </MenuItem>
                      <MenuItem value={"Healthcare"}>Healthcare</MenuItem>
                      <MenuItem value={"Hospitality"}>Hospitality</MenuItem>
                      <MenuItem value={"IT Technology"}>IT Technology</MenuItem>
                      <MenuItem value={"Media"}>Media</MenuItem>
                      <MenuItem value={"Pharmaceutical"}>
                        Pharmaceutical
                      </MenuItem>
                      <MenuItem value={"Real Estate"}>Real Estate</MenuItem>
                      <MenuItem value={"Retail"}>Retail</MenuItem>
                      <MenuItem value={"Tourism"}>Tourism</MenuItem>
                      <MenuItem value={"Telecommunication"}>
                        Telecommunication
                      </MenuItem>
                    </TextField>
                  </FormControl>
                  {errors.industry && (
                    <p className="errorMessage">{errors.industry.message}</p>
                  )}
                  <div style={{ margin: "10px 0" }} />
                </Grid>
              </Grid>
              <div style={{ margin: "10px 0" }} />
              <h2 className="redHeading">
                <HomeIcon />
                Outlet Info
              </h2>
              <Grid container columnSpacing={4}>
                <Grid container item xs={12} md={6} direction="column">
                  <TextField
                    variant="outlined"
                    label="Outlet Name *"
                    size="small"
                    {...register("outletName")}
                    onChange={(e) => handleInputChange("outletName", e)}
                  />
                  {errors.outletName && (
                    <p className="errorMessage">{errors.outletName.message}</p>
                  )}
                  <div style={{ margin: "10px 0" }} />

                  <TextField
                    variant="outlined"
                    label="Outlet Address *"
                    size="small"
                    {...register("outletAddress")}
                    fullWidth
                    color="primary"
                    multiline
                    rows={4}
                    inputRef={mapRef}
                    value={outletAddress}
                    onChange={(e) => handleInputChange("outletAddress", e)}
                  />

                  {errors.outletAddress && (
                    <p className="errorMessage">
                      {errors.outletAddress.message}
                    </p>
                  )}
                  <div style={{ margin: "10px 0" }} />
                </Grid>
                <Grid container item xs={12} md={6} direction="column">
                  <TextField
                    variant="outlined"
                    label="Outlet Postcode *"
                    size="small"
                    {...register("postCode")}
                    value={postCode}
                    onChange={(e) => handleInputChange("postCode", e)}
                  />
                  {errors.postCode && (
                    <p className="errorMessage">{errors.postCode.message}</p>
                  )}
                  <div style={{ margin: "10px 0" }} />

                  {isMalaysia ? (
                    <TextField
                      variant="outlined"
                      select
                      size="small"
                      {...register("stateDDL")}
                      // Tan Zin Wei, 2023-11-28, Comment the minWidth
                      // sx={{ m: 1, minWidth: 120 }}
                      value={stateDDL}
                      onChange={(e) => handleInputChange("stateDDL", e)}
                      label="Outlet State*"
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value={"Johor"}>Johor</MenuItem>
                      <MenuItem value={"Kedah"}>Kedah</MenuItem>
                      <MenuItem value={"Kelantan"}>Kelantan</MenuItem>
                      <MenuItem value={"Melaka"}>Melaka</MenuItem>
                      <MenuItem value={"Negeri Sembilan"}>
                        Negeri Sembilan
                      </MenuItem>
                      <MenuItem value={"Pahang"}>Pahang</MenuItem>
                      <MenuItem value={"Perak"}>Perak</MenuItem>
                      <MenuItem value={"Perlis"}>Perlis</MenuItem>
                      <MenuItem value={"Pulau Pinang"}>Pulau Pinang</MenuItem>
                      <MenuItem value={"Sabah"}>Sabah</MenuItem>
                      <MenuItem value={"Sarawak"}>Sarawak</MenuItem>
                      <MenuItem value={"Selangor"}>Selangor</MenuItem>
                      <MenuItem value={"Terengganu"}>Terengganu</MenuItem>
                      <MenuItem value={"Wilayah Persekutuan Kuala Lumpur"}>
                        Wilayah Persekutuan Kuala Lumpur
                      </MenuItem>
                      <MenuItem value={"Wilayah Persekutuan Labuan"}>
                        Wilayah Persekutuan Labuan
                      </MenuItem>
                      <MenuItem value={"Wilayah Persekutuan Putrajaya"}>
                        Wilayah Persekutuan Putrajaya
                      </MenuItem>
                    </TextField>
                  ) : (
                    <TextField
                      variant="outlined"
                      label="Outlet State *"
                      size="small"
                      {...register("state")}
                      value={state}
                      onChange={(e) => handleInputChange("state", e)}
                    />
                  )}
                  {errors.state && (
                    <p className="errorMessage">{errors.state.message}</p>
                  )}
                  <div style={{ margin: "10px 0" }} />

                  <FormControl>
                    <TextField
                      variant="outlined"
                      select
                      size="small"
                      {...register("country")}
                      // Tan Zin Wei, 2023-11-28, Comment the minWidth
                      // sx={{ m: 1, minWidth: 120 }}
                      value={country}
                      onChange={(e) => handleInputChange("country", e)}
                      label="Outlet Country*"
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value={"AFG"}>Afghanistan</MenuItem>
                      <MenuItem value={"ALB"}>Albania</MenuItem>
                      <MenuItem value={"ALG"}>Algeria</MenuItem>
                      <MenuItem value={"AND"}>Andorra</MenuItem>
                      <MenuItem value={"ANG"}>Angola</MenuItem>
                      <MenuItem value={"ANU"}>Anguilla</MenuItem>
                      <MenuItem value={"ANT"}>Antigua And Barbuda</MenuItem>
                      <MenuItem value={"ARG"}>Argentina</MenuItem>
                      <MenuItem value={"ARM"}>Armenia</MenuItem>
                      <MenuItem value={"ARU"}>Aruba</MenuItem>
                      <MenuItem value={"AUS"}>Australia</MenuItem>
                      <MenuItem value={"AUT"}>Austria</MenuItem>
                      <MenuItem value={"AZE"}>Azerbaijian</MenuItem>
                      <MenuItem value={"AMS"}>American Samoa</MenuItem>
                      <MenuItem value={"BHM"}>Bahamas</MenuItem>
                      <MenuItem value={"BHR"}>Bahrain</MenuItem>
                      <MenuItem value={"BGD"}>Bangladesh</MenuItem>
                      <MenuItem value={"BBD"}>Barbados</MenuItem>
                      <MenuItem value={"BEL"}>Belarus</MenuItem>
                      <MenuItem value={"BGM"}>Belgium</MenuItem>
                      <MenuItem value={"BLZ"}>Belize</MenuItem>
                      <MenuItem value={"BEN"}>Benin</MenuItem>
                      <MenuItem value={"BMD"}>Bermuda</MenuItem>
                      <MenuItem value={"BHU"}>Bhutan</MenuItem>
                      <MenuItem value={"BOL"}>Bolivia</MenuItem>
                      <MenuItem value={"BOS"}>Bosnia-Herzegovina</MenuItem>
                      <MenuItem value={"BWN"}>Botswana</MenuItem>
                      <MenuItem value={"BOU"}>Bouvet Island</MenuItem>
                      <MenuItem value={"BRA"}>Brazil</MenuItem>
                      <MenuItem value={"BRU"}>Brunei</MenuItem>
                      <MenuItem value={"BUL"}>Bulgaria</MenuItem>
                      <MenuItem value={"BUR"}>Burkina Faso</MenuItem>
                      <MenuItem value={"BUD"}>Burundi</MenuItem>
                      <MenuItem value={"CAM"}>Cambodia</MenuItem>
                      <MenuItem value={"CAR"}>Cameroon</MenuItem>
                      <MenuItem value={"CND"}>Canada</MenuItem>
                      <MenuItem value={"CAP"}>Cape Verde</MenuItem>
                      <MenuItem value={"CAY"}>Cayman Islands</MenuItem>
                      <MenuItem value={"CEN"}>
                        Central African Republic
                      </MenuItem>
                      <MenuItem value={"CHA"}>Chad</MenuItem>
                      <MenuItem value={"CHI"}>Chile</MenuItem>
                      <MenuItem value={"CHN"}>China</MenuItem>
                      <MenuItem value={"CHR"}>Christmas Island</MenuItem>
                      <MenuItem value={"COC"}>Cocos (Keeling) Islands</MenuItem>
                      <MenuItem value={"COL"}>Colombia</MenuItem>
                      <MenuItem value={"COM"}>Comoros</MenuItem>
                      <MenuItem value={"COR"}>Congo, Republic Of</MenuItem>
                      <MenuItem value={"COO"}>Cook Islands</MenuItem>
                      <MenuItem value={"COS"}>Costa Rica</MenuItem>
                      <MenuItem value={"CRO"}>Croatia</MenuItem>
                      <MenuItem value={"CUB"}>Cuba</MenuItem>
                      <MenuItem value={"CYP"}>Cyprus</MenuItem>
                      <MenuItem value={"CZR"}>Czech Republic</MenuItem>
                      <MenuItem value={"HKG"}>Hong Kong</MenuItem>
                      <MenuItem value={"IDN"}>Indonesia</MenuItem>
                      <MenuItem value={"DEN"}>Denmark</MenuItem>
                      <MenuItem value={"DJI"}>Djibouti</MenuItem>
                      <MenuItem value={"DOM"}>Dominica</MenuItem>
                      <MenuItem value={"DOP"}>Dominican Republic</MenuItem>
                      <MenuItem value={"ECU"}>Ecuador</MenuItem>
                      <MenuItem value={"EGY"}>Egypt</MenuItem>
                      <MenuItem value={"ELS"}>El Salvador</MenuItem>
                      <MenuItem value={"EQU"}>Equatorial Guinea</MenuItem>
                      <MenuItem value={"ERI"}>Eritrea</MenuItem>
                      <MenuItem value={"EST"}>Estonia</MenuItem>
                      <MenuItem value={"ETH"}>Ethiopia</MenuItem>
                      <MenuItem value={"FAL"}>Falkland Islands</MenuItem>
                      <MenuItem value={"FAR"}>Faroe Islands</MenuItem>
                      <MenuItem value={"FIJ"}>Fiji</MenuItem>
                      <MenuItem value={"FIN"}>Finland</MenuItem>
                      <MenuItem value={"FRA"}>France</MenuItem>
                      <MenuItem value={"FRE"}>French Guiana</MenuItem>
                      <MenuItem value={"GAB"}>Gabon</MenuItem>
                      <MenuItem value={"GAM"}>Gambia</MenuItem>
                      <MenuItem value={"GEO"}>Georgia</MenuItem>
                      <MenuItem value={"GER"}>Germany</MenuItem>
                      <MenuItem value={"GHA"}>Ghana</MenuItem>
                      <MenuItem value={"GIB"}>Gibraltar</MenuItem>
                      <MenuItem value={"GRE"}>Greece</MenuItem>
                      <MenuItem value={"GRL"}>Greenland</MenuItem>
                      <MenuItem value={"GRN"}>Grenada</MenuItem>
                      <MenuItem value={"GUA"}>Guadeloupe (French)</MenuItem>
                      <MenuItem value={"GUM"}>Guam (Usa)</MenuItem>
                      <MenuItem value={"GUT"}>Guatemala</MenuItem>
                      <MenuItem value={"GUI"}>Guinea</MenuItem>
                      <MenuItem value={"GUB"}>Guinea Bissau</MenuItem>
                      <MenuItem value={"GUY"}>Guyana</MenuItem>
                      <MenuItem value={"HAI"}>Haiti</MenuItem>
                      <MenuItem value={"HOL"}>Holy See</MenuItem>
                      <MenuItem value={"HON"}>Honduras</MenuItem>
                      <MenuItem value={"HUN"}>Hungary</MenuItem>
                      <MenuItem value={"ICE"}>Iceland</MenuItem>
                      <MenuItem value={"IND"}>India</MenuItem>
                      <MenuItem value={"IRN"}>Iran</MenuItem>
                      <MenuItem value={"IRQ"}>Iraq</MenuItem>
                      <MenuItem value={"IRE"}>Ireland</MenuItem>
                      <MenuItem value={"ISR"}>Israel</MenuItem>
                      <MenuItem value={"ITA"}>Italy</MenuItem>
                      <MenuItem value={"IVO"}>
                        Ivory Coast (Cote D'Ivoire)
                      </MenuItem>
                      <MenuItem value={"JAM"}>Jamaica</MenuItem>
                      <MenuItem value={"JPN"}>Japan</MenuItem>
                      <MenuItem value={"JOR"}>Jordan</MenuItem>
                      <MenuItem value={"KAZ"}>Kazakhstan</MenuItem>
                      <MenuItem value={"KEN"}>Kenya</MenuItem>
                      <MenuItem value={"KIR"}>Kiribati</MenuItem>
                      <MenuItem value={"KUW"}>Kuwait</MenuItem>
                      <MenuItem value={"KYR"}>Kyrgyzstan</MenuItem>
                      <MenuItem value={"LAO"}>Laos</MenuItem>
                      <MenuItem value={"LAT"}>Latvia</MenuItem>
                      <MenuItem value={"LEB"}>Lebanon</MenuItem>
                      <MenuItem value={"LES"}>Lesotho</MenuItem>
                      <MenuItem value={"LIB"}>Liberia</MenuItem>
                      <MenuItem value={"LBY"}>Libya</MenuItem>
                      <MenuItem value={"LIE"}>Liechtenstein</MenuItem>
                      <MenuItem value={"LIT"}>Lithuania</MenuItem>
                      <MenuItem value={"LUX"}>Luxembourg</MenuItem>
                      <MenuItem value={"MCA"}>Macau</MenuItem>
                      <MenuItem value={"MAC"}>Macedonia</MenuItem>
                      <MenuItem value={"MAD"}>Madagascar</MenuItem>
                      <MenuItem value={"MLW"}>Malawi</MenuItem>
                      <MenuItem value={"MYS"}>Malaysia</MenuItem>
                      <MenuItem value={"MDV"}>Maldives</MenuItem>
                      <MenuItem value={"MAL"}>Mali</MenuItem>
                      <MenuItem value={"MLT"}>Malta</MenuItem>
                      <MenuItem value={"MAR"}>Marshall Islands</MenuItem>
                      <MenuItem value={"MTQ"}>Martinique (French)</MenuItem>
                      <MenuItem value={"MTA"}>Mauritania</MenuItem>
                      <MenuItem value={"MTS"}>Mauritius</MenuItem>
                      <MenuItem value={"MAY"}>Mayotte</MenuItem>
                      <MenuItem value={"MEX"}>Mexico</MenuItem>
                      <MenuItem value={"MIC"}>Micronesia</MenuItem>
                      <MenuItem value={"MLV"}>Moldova</MenuItem>
                      <MenuItem value={"MOC"}>Monaco</MenuItem>
                      <MenuItem value={"MGL"}>Mongolia</MenuItem>
                      <MenuItem value={"MTN"}>Montenegro</MenuItem>
                      <MenuItem value={"MSR"}>Montserrat</MenuItem>
                      <MenuItem value={"MRC"}>Morocco</MenuItem>
                      <MenuItem value={"MOZ"}>Mozambique</MenuItem>
                      <MenuItem value={"MYN"}>Myanmar</MenuItem>
                      <MenuItem value={"NAM"}>Namibia</MenuItem>
                      <MenuItem value={"NAU"}>Nauru</MenuItem>
                      <MenuItem value={"NEP"}>Nepal</MenuItem>
                      <MenuItem value={"NET"}>Netherlands</MenuItem>
                      <MenuItem value={"NTA"}>Netherlands Antilles</MenuItem>
                      <MenuItem value={"NCA"}>New Caledonia (French)</MenuItem>
                      <MenuItem value={"NZL"}>New Zeland</MenuItem>
                      <MenuItem value={"NIC"}>Nicaragua</MenuItem>
                      <MenuItem value={"NIR"}>Niger</MenuItem>
                      <MenuItem value={"NIG"}>Nigeria</MenuItem>
                      <MenuItem value={"NIU"}>Niue</MenuItem>
                      <MenuItem value={"NFI"}>Norfolk Island</MenuItem>
                      <MenuItem value={"NKR"}>North Korea</MenuItem>
                      <MenuItem value={"NMI"}>
                        Northern Mariana Islands
                      </MenuItem>
                      <MenuItem value={"NOR"}>Norway</MenuItem>
                      <MenuItem value={"OMN"}>Oman</MenuItem>
                      <MenuItem value={"PAK"}>Pakistan</MenuItem>
                      <MenuItem value={"PAL"}>Palau</MenuItem>
                      <MenuItem value={"PAN"}>Panama</MenuItem>
                      <MenuItem value={"PAP"}>Papua New Guinea</MenuItem>
                      <MenuItem value={"PAR"}>Paraguay</MenuItem>
                      <MenuItem value={"PER"}>Peru</MenuItem>
                      <MenuItem value={"PHI"}>Philippines</MenuItem>
                      <MenuItem value={"PIT"}>Pitcairn Island</MenuItem>
                      <MenuItem value={"POL"}>Poland</MenuItem>
                      <MenuItem value={"PNS"}>Polynesia (French)</MenuItem>
                      <MenuItem value={"POR"}>Portugal</MenuItem>
                      <MenuItem value={"PUE"}>Puerto Rico</MenuItem>
                      <MenuItem value={"QAT"}>Qatar</MenuItem>
                      <MenuItem value={"REU"}>Reunion</MenuItem>
                      <MenuItem value={"ROM"}>Romania</MenuItem>
                      <MenuItem value={"RUS"}>Russia</MenuItem>
                      <MenuItem value={"RWA"}>Rwanda</MenuItem>
                      <MenuItem value={"SAH"}>Saint Helena</MenuItem>
                      <MenuItem value={"SAK"}>Saint Kitts And Nevis</MenuItem>
                      <MenuItem value={"SAM"}>Samoa</MenuItem>
                      <MenuItem value={"SAN"}>San Marino</MenuItem>
                      <MenuItem value={"SAO"}>Sao Tome And Principe</MenuItem>
                      <MenuItem value={"SAU"}>Saudi Arabia</MenuItem>
                      <MenuItem value={"SEN"}>Senegal</MenuItem>
                      <MenuItem value={"SER"}>Serbia</MenuItem>
                      <MenuItem value={"SEY"}>Seychelles</MenuItem>
                      <MenuItem value={"SIE"}>Sierra Leone</MenuItem>
                      <MenuItem value={"SGP"}>Singapore</MenuItem>
                      <MenuItem value={"SLO"}>Slovakia</MenuItem>
                      <MenuItem value={"SBN"}>Slovenia</MenuItem>
                      <MenuItem value={"SOL"}>Solmon Islands</MenuItem>
                      <MenuItem value={"SOM"}>Somalia</MenuItem>
                      <MenuItem value={"SAF"}>South Africa</MenuItem>
                      <MenuItem value={"SKR"}>South Korea</MenuItem>
                      <MenuItem value={"SPA"}>Spain</MenuItem>
                      <MenuItem value={"SRI"}>Sri Lanka</MenuItem>
                      <MenuItem value={"SUD"}>Sudan</MenuItem>
                      <MenuItem value={"SUR"}>Suriname</MenuItem>
                      <MenuItem value={"SWA"}>Swaziland</MenuItem>
                      <MenuItem value={"SWE"}>Sweden</MenuItem>
                      <MenuItem value={"SWI"}>Switzerland</MenuItem>
                      <MenuItem value={"SYR"}>Syria</MenuItem>
                      <MenuItem value={"SLC"}>Saint Lucia</MenuItem>
                      <MenuItem value={"SAP"}>
                        Saint Pierre And Miquelon
                      </MenuItem>
                      <MenuItem value={"TWN"}>Taiwan</MenuItem>
                      <MenuItem value={"TAJ"}>Tajikistan</MenuItem>
                      <MenuItem value={"TAN"}>Tanzania</MenuItem>
                      <MenuItem value={"THI"}>Thailand</MenuItem>
                      <MenuItem value={"TIM"}>
                        Timor-Leste (East Timor)
                      </MenuItem>
                      <MenuItem value={"TOG"}>Togo</MenuItem>
                      <MenuItem value={"TOK"}>Tokelau</MenuItem>
                      <MenuItem value={"TON"}>Tonga</MenuItem>
                      <MenuItem value={"TRI"}>Trinidad And Tobago</MenuItem>
                      <MenuItem value={"TUN"}>Tunisia</MenuItem>
                      <MenuItem value={"TUR"}>Turkey</MenuItem>
                      <MenuItem value={"TRK"}>Turkmenistan</MenuItem>
                      <MenuItem value={"TCI"}>
                        Turks And Caicos Islands
                      </MenuItem>
                      <MenuItem value={"TUV"}>Tuvalu</MenuItem>
                      <MenuItem value={"UGA"}>Uganda</MenuItem>
                      <MenuItem value={"UKR"}>Ukraine</MenuItem>
                      <MenuItem value={"UAE"}>United Arab Emirates</MenuItem>
                      <MenuItem value={"UKD"}>United Kingdom</MenuItem>
                      <MenuItem value={"USA"}>United States</MenuItem>
                      <MenuItem value={"URU"}>Uruguay</MenuItem>
                      <MenuItem value={"UZB"}>Uzbekistan</MenuItem>
                      <MenuItem value={"VAN"}>Vanuatu</MenuItem>
                      <MenuItem value={"VEN"}>Venezuela</MenuItem>
                      <MenuItem value={"VTN"}>Vietnam</MenuItem>
                      <MenuItem value={"VIR"}>Virgin Islands</MenuItem>
                      <MenuItem value={"WAL"}>
                        Wallis And Futuna Islands
                      </MenuItem>
                      <MenuItem value={"YEM"}>Yemen</MenuItem>
                      <MenuItem value={"ZAM"}>Zambia</MenuItem>
                      <MenuItem value={"ZIM"}>Zimbabwe</MenuItem>
                    </TextField>
                  </FormControl>
                  <div style={{ margin: "10px 0" }} />
                </Grid>
              </Grid>

              <h2 className="redHeading">
                <CallIcon />
                Contact Info
              </h2>
              <Grid container columnSpacing={4}>
                <Grid container item xs={12} md={6} direction="column">
                  <TextField
                    variant="outlined"
                    label="Your Name *"
                    size="small"
                    {...register("picName")}
                    onChange={(e) => handleInputChange("picName", e)}
                  />
                  {errors.picName && (
                    <p className="errorMessage">{errors.picName.message}</p>
                  )}
                  <div style={{ margin: "10px 0" }} />

                  <FormControl>
                    <Controller
                      name="picContactNo"
                      control={control}
                      rules={{
                        required: true,
                        validate: (value) => isValidPhoneNumber(value),
                      }}
                      render={({ field: { onChange, value } }) => (
                        <PhoneInput
                          specialLabel="Your Contact No. *"
                          value={value}
                          onChange={onChange}
                          country="my"
                          id="picContactNo"
                          // Tan Zin Wei, 2023-11-28, Set the Width to 100%
                          inputStyle={{ height: "40px", width: "100%" }}
                        />
                      )}
                    />
                  </FormControl>

                  {errors.picContactNo && (
                    <p className="errorMessage">
                      {errors.picContactNo.message}
                    </p>
                  )}
                  <div style={{ margin: "10px 0" }} />
                </Grid>
                <Grid container item xs={12} md={6} direction="column">
                  <TextField
                    variant="outlined"
                    label="Your Email *"
                    size="small"
                    {...register("picEmail")}
                    onChange={(e) => handleInputChange("picEmail", e)}
                  />
                  {errors.picEmail && (
                    <p className="errorMessage">{errors.picEmail.message}</p>
                  )}
                  <div style={{ margin: "10px 0" }} />
                </Grid>
              </Grid>

              <div className="checkbox tncDiv">
                <label>
                  <input
                    type="checkbox"
                    {...register("tnc", { required: true })}
                  />
                  <span style={{ marginLeft: "5px" }}>
                    By ticking, you have agreed to{" "}
                    <a
                      href="https://haiico.com/terms-and-conditions/?partners"
                      target="_blank"
                    >
                      Terms & Conditions
                    </a>{" "}
                    as stated.
                  </span>
                </label>
                {errors.tnc && (
                  <p className="errorMessage">
                    You must tick checkbox to agree with our T&C.
                  </p>
                )}
              </div>

                <Dialog open={open} onClose={handleClose}>
                  <form onSubmit={(e) => handleSubmit(handleInnerFormSubmit)(e)} style={{ margin: "0", borderRadius: 0, display: "block", minHeight: "unset", padding: "5px" }}>
                    <DialogTitle>Email verification</DialogTitle>
                    <IconButton
                      aria-label="close"
                      onClick={handleClose}
                      sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                      }}
                      style={{
                        padding: "8px",
                        display: "flex",
                        background: "none",
                        color: "black",
                        borderRadius: "50%",
                        transition: "background-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                      }}
                      onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.04)")}
                      onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                    >
                      <CloseIcon />
                    </IconButton>
                    <DialogContent>
                        <DialogContentText>
                            Verification email has been sent. Please enter the verification code to proceed.
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Verification Code *"
                            type="text"
                            fullWidth
                            variant="standard"
                            name="verificationCode"
                            inputProps={{ maxLength: 6 }}
                            {...register("verificationCode")}
                        />
                        {verificationErrorMessage && (
                          <p className="errorMessage">{verificationErrorMessage}</p>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <button type="submit" className="btn btn-danger mr-1" style={{ margin: "0px auto 10px auto" }}>Submit</button>
                    </DialogActions>
                  </form>
                </Dialog>
              
              <div className="recaptchaDiv" style={{ zIndex: 100 }}>
                <ReCAPTCHA
                  sitekey="6LcTP8opAAAAACjiZVL7Yx_Yy9H3UC5vEAO-xlig"
                  size="invisible"
                  ref={reCaptchaRef}
                  onChange={onChange}
                />
              </div>
              <div className="recaptchaErr">
                {recaptchaErr && (
                  <p className="errorMessage">
                    You must complete the reCAPTCHA challenge
                  </p>
                )}
              </div>

              <div className="submitButton">
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-danger mr-1"
                >
                  {loading && (
                    <span className="spinner-border spinner-border-sm mr-1"></span>
                  )}
                  {loading ? "Creating Profile, Please Wait." : "Submit"}
                </button>
              </div>
            </form>
          );
        } else {
          return (
            <div className="success">
              <div id="AlertMsg">
                {isSuccess && !isResendSuccess && (
                  <Alert id="successMsg" severity="success">
                    Your account has been created successfully! Please check
                    your email at{" "}
                    <b className="text-danger">{responseEmailAddr}</b> for the
                    get-started email.
                    <div style={{ margin: "20px 0" }} />
                    If you did not receive the email, please click the button
                    below to resend the email.
                  </Alert>
                )}
                <div style={{ margin: "10px 0" }} />
              </div>
              <div id="ResendMail">
                {isSuccess && (
                  <div>
                    {isResendSuccess && (
                      <div>
                        <div style={{ margin: "10px 0" }} />
                        <Alert id="" severity="success">
                          <span>
                            Welcome email has been successfully resent to email
                            address{" "}
                            <b className="text-danger">{responseEmailAddr}</b>.
                            <div style={{ margin: "20px 0" }} />
                            If you still have not receive the email after
                            resending, please send an email to{" "}
                            <a href="mailto:sayhai@haiico.com">
                              sayhai@haiico.com
                            </a>
                            &nbsp;or call us at{" "}
                            <a href="tel:601111008062">+60 11-1100 8062</a>.
                          </span>
                        </Alert>
                      </div>
                    )}
                    {isResendFail && (
                      <div>
                        <div style={{ margin: "10px 0" }} />
                        <Alert id="" severity="error">
                          <span>
                            Unable to resend welcome email to email address{" "}
                            <b className="text-danger">{responseEmailAddr}</b>.
                            Please try again.
                          </span>
                        </Alert>
                      </div>
                    )}
                    <div style={{ margin: "10px 0" }} />
                    <div className="submitButton">
                      <button
                        type="button"
                        id="btn-resend"
                        onClick={() => handleResendEmail(responseClientId)}
                        disabled={loading}
                        className="btn btn-danger mr-1"
                      >
                        {loading && (
                          <span className="spinner-border spinner-border-sm mr-1"></span>
                        )}
                        {loading
                          ? "Sending Email, Please Wait."
                          : "Resend Email"}
                      </button>
                    </div>
                  </div>
                )}
                <div style={{ margin: "10px 0" }} />
              </div>
            </div>
          );
        }
      })()}
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

function App1() {
  let year = new Date().getFullYear();

  return (
    <Footer />
    // <section className="sectionRed">
    //   <div className="container-fluid">
    //     <div className="bottomRow">
    //       <div className="row">
    //         <div className="col-lg-1"></div>
    //         <div className="col-lg-5 col-md-12">
    //           <div className="col-md-12">
    //             <div className="tagDiv-left">
    //               <img className="footerLogoImg" src={footerImage} />
    //             </div>
    //           </div>

    //           <div className="col-md-12">
    //             <label className="bottomLabel">
    //               <strong>HAi!CO</strong> is a Loyalty Program App and it serves
    //               as a Platform-As-A-Service for customers and merchants. We
    //               empower businesses to execute their loyalty strategy to grow
    //               long-term customer relationships, using our proven customer
    //               loyalty program.
    //             </label>
    //           </div>

    //           <div className="col-md-12">
    //             <div className="footerIconDiv">
    //               <a
    //                 href="https://apps.apple.com/my/app/id552289119"
    //                 target="_blank"
    //               >
    //                 <img className="footerIconImg" src={appleImage} />
    //               </a>
    //               <a
    //                 href="https://play.google.com/store/apps/details?id=com.cardsys.lms.mobile"
    //                 target="_blank"
    //               >
    //                 <img className="footerIconImg" src={googleImage} />
    //               </a>
    //               <a
    //                 href="https://appgallery.huawei.com/app/C102646837"
    //                 target="_blank"
    //               >
    //                 <img className="footerIconImg" src={huaweiImage} />
    //               </a>
    //             </div>
    //           </div>

    //           <div className="col-md-12">
    //             <div className="copyrightDiv">
    //               <label className="copyright">
    //                 Copyright {year} @ CardSys Sdn. Bhd. (407836-T).
    //               </label>
    //             </div>
    //           </div>
    //         </div>

    //         <div className="col-lg-2 col-md-12">
    //           <div className="tagDiv-mid">
    //             <h4>Quick Link</h4>
    //             <a href="https://haiico.com/community" target="_blank">
    //               Community
    //             </a>
    //             <a href="https://haiico.com/become-our-partner" target="_blank">
    //               Become Our Partner
    //             </a>
    //             <a
    //               href="https://haiico.com/become-our-partner/?pricing"
    //               target="_blank"
    //             >
    //               Pricing
    //             </a>
    //             <a href="https://haiico.com/contact-us" target="_blank">
    //               Contact Us
    //             </a>
    //           </div>
    //         </div>

    //         <div className="col-lg-2 col-md-12">
    //           <div className="tagDiv-mid">
    //             <h4>Support</h4>
    //             <a href="https://haiico.com/news-and-articles" target="_blank">
    //               News & Articles
    //             </a>
    //             <a href="https://haiico.com/faqs" target="_blank">
    //               FAQ's
    //             </a>
    //           </div>
    //         </div>

    //         <div className="col-lg-2 col-md-12">
    //           <div className="tagDiv-mid">
    //             <h4>Follow us</h4>
    //             <a href="https://www.facebook.com/haiicoapp" target="_blank">
    //               <FacebookRoundedIcon />
    //               <label>Facebook</label>
    //             </a>
    //             <a href="https://www.instagram.com/haiico.app/" target="_blank">
    //               <InstagramIcon />
    //               <label>Instagram</label>
    //             </a>
    //           </div>

    //           <div className="tagDiv-bottom">
    //             <a
    //               href="https://haiico.com/terms-and-conditions/?user"
    //               target="_blank"
    //             >
    //               Terms & Conditions (User)
    //             </a>
    //             <span>|</span>
    //             <a
    //               href="https://haiico.com/terms-and-conditions/?partners"
    //               target="_blank"
    //             >
    //               Terms & Conditions (Partners)
    //             </a>
    //             <span>|</span>
    //             <a href="https://haiico.com/privacy-policy" target="_blank">
    //               Privacy Policy
    //             </a>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>

    //   <div className="wave">
    //     <svg
    //       data-name="Layer 1"
    //       xmlns="http://www.w3.org/2000/svg"
    //       viewBox="0 0 1200 120"
    //       preserveAspectRatio="none"
    //     >
    //       <path
    //         d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
    //         className="shape-fill"
    //       ></path>
    //     </svg>
    //   </div>
    // </section>
  );
}

const footer = ReactDOM.createRoot(document.getElementById("footer"));
footer.render(<App1 />);
